const React = require('react');
const {AdminCard} = require('../../../../../../../dumb/AdminHelpers/AdminLayout');
const {BtnWithIcon} = require('../../../../../../../dumb/AdminHelpers/Buttons');

const TotalBalanceDisplay = ({symbol, value, reverse}) => (
  <div
    className={
      `layoutRow aiC f20 mr20 cF.reverse`
      + (reverse ? ` reverse` : '')
    }
  >
    <span className="dB w55 mr5 fw7">
      {symbol}
    </span>
    <span className="fw8">
      {value}
    </span>
  </div>
)

const BalanceField = ({label, value, reverse}) => (
  <div
    className={
      `w
      (dB|mb14|f12|lh18)>.label
      (h45|layoutRow|aiC|pl24|pr14|f16|fw7|bgF|r9|bxsh2y1c0.25in)>.field
      (cF).reverse>.label
      (bg515151|cF).reverse>.field
      ` + (reverse ? ' reverse' : '')
    }
  >
    <span className="label">
      {label}
    </span>
    <div className="field">
      {value}
    </div>
  </div>
)


module.exports = ({
  balance,
  available,
  reserved,
  symbol,
  reverse
}) => {
  return (
    <AdminCard reverse={reverse}>
      <div className="layoutRow aiC">
        <TotalBalanceDisplay
          symbol={symbol}
          value={balance}
          reverse={reverse}
        />
        <div className="mlAuto">
          <BtnWithIcon
            text="Send Payment"
            icon=">"
            reverse={reverse}
          />
        </div>
      </div>
      <div className="layoutRow mt15 mh-9 pb15 (w1/2|ph9)>1">
        <div>
          <BalanceField
            label="Available"
            value={available}
            reverse={reverse}
          />
        </div>
        <div>
          <BalanceField
            label="Reserved"
            value={reserved}
            reverse={reverse}
          />
        </div>
      </div>
    </AdminCard>
  )
}
